import React, { useEffect } from 'react';
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import { useParams } from "react-router";

import { ChevronDoubleDownIcon, MagnifyingGlassIcon } from '@heroicons/react/20/solid'

const partnersArr = [
    {
        name: 'UpStox',
        status: 'Buddy Expert',
        image:
            'https://bizbehindsports.com/wp-content/uploads/2021/07/51003444_2378086569081776_6714125917737713664_n.jpg',
        color: 'rgb(28,69,186)',
        bio: 'Quia illum aut in beatae. Possimus dolores aliquid accusantium aut in ut non assumenda. Enim iusto molestias aut deleniti eos aliquid magnam molestiae. At et non possimus ab. Magni labore molestiae nulla qui.',
        integrations: 2,
        industries: 3,
    },
    {
        name: 'Xero',
        status: 'Buddy Expert',
        image:
            'https://lawyerist.com/wp-content/uploads/2017/05/Xero-Logo.png',
        color: 'rgb(61,183,227)',
        bio: 'Quia illum aut in beatae. Possimus dolores aliquid accusantium aut in ut non assumenda. Enim iusto molestias aut deleniti eos aliquid magnam molestiae. At et non possimus ab. Magni labore molestiae nulla qui.',
        integrations: 1,
        industries: 2,
    },
]

function Partner({
    contactInList,
    profile,
})
{
    let { slug } = useParams();
    useEffect(() => {
        if (profile && profile.email) {
            contactInList({
                email: profile.email,
            })
        }
    }, [profile && profile.email]);
    return (
        <React.Fragment>
            <Helmet>
                <title>Partners | Buddy</title>
                <meta name="description" content="" />
                <link rel="canonical" href={`https://www.buddy.hr/partners`} />
            </Helmet>
            <main className="relative bg-orange-600">
                <div className="relative mx-auto max-w-2xl px-4 pt-16 text-center sm:px-6 sm:pt-32 lg:max-w-7xl lg:px-8">
                    <h1 className="text-4xl font-bold tracking-tight text-white sm:text-6xl">
                        <span className="block lg:inline">Looking for an Advisor?</span>
                    </h1>
                    <p className="mt-4 text-xl text-orange-100">
                        Finding a professional Advisor based on your company's industry ensures better compliance.
                    </p>
                </div>

                <div className="mx-auto mt-2 w-96 flex shadow-sm pt-12">
                    <input
                        type="text"
                        name="search"
                        id="search"
                        className="bg-white block w-full min-w-0 flex-1 rounded-l-xl border-none text-gray-900 placeholder:text-gray-400 sm:text-sm sm:leading-6 focus:ring-0"
                        placeholder="Search"
                    />
                    <a href="#" className="bg-white inline-flex items-center rounded-r-xl border-l-2 border-orange-600 p-3 sm:text-sm">
                        <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </a>
                </div>

                <div className="mx-auto w-96 text-orange-100 pb-12">
                    <p className="flex text-sm ml-2.5 mt-2">
                        Advanced Options
                        <ChevronDoubleDownIcon className="mt-1 ml-1 h-3 w-3 align-baseline" aria-hidden="true" />
                    </p>
                </div>
            </main>

            <div className="relative py-16 bg-white overflow-hidden">
                <div className="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
                    <div className="relative h-full text-lg max-w-prose mx-auto">
                        <svg className="absolute top-12 left-full transform translate-x-32" width="404" height="384" fill="none" viewBox="0 0 404 384">
                            <defs>
                                <pattern id="74b3fd99-0a6f-4271-bef2-e80eeafdf357" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                                    <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
                                </pattern>
                            </defs>
                            <rect width="404" height="384" fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)" />
                        </svg>
                        <svg className="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32" width="404" height="384" fill="none" viewBox="0 0 404 384">
                            <defs>
                                <pattern id="f210dbf6-a58d-4871-961e-36d5016a0f49" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                                    <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
                                </pattern>
                            </defs>
                            <rect width="404" height="384" fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)" />
                        </svg>
                        <svg className="absolute bottom-12 left-full transform translate-x-32" width="404" height="384" fill="none" viewBox="0 0 404 384">
                            <defs>
                                <pattern id="d3eb07ae-5182-43e6-857d-35c643af9034" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                                    <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
                                </pattern>
                            </defs>
                            <rect width="404" height="384" fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)" />
                        </svg>
                    </div>
                </div>

                <div className="relative pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8">
                    <div className="relative max-w-7xl mx-auto">
                        <div className="mx-auto max-w-3xl px-6 lg:px-8 sm:w-2/3">
                            <ul role="list" className="mx-auto">
                                {partnersArr.map((partner) => (
                                    <li key={partner.name} className="rounded-2xl overflow-hidden flex flex-col lg:flex-row bg-gray-50 mb-16 drop-shadow-lg text-left">
                                        <img className="flex-none object-scale-down object-left max-h-16 lg:max-h-fit lg:object-cover lg:object-center md:aspect-[4/3] lg:w-52" style={{backgroundColor:partner.color}} src={partner.image} />
                                        
                                        <div className="flex-auto p-5">
                                            <h3 className="inline pr-4 text-2xl tracking-tight text-gray-900">{partner.name}</h3>
                                            <h3 className="inline align-[2px] text-1xl tracking-tight text-gray-400">★ {partner.status}</h3>

                                            <p className="mt-2 h-fit text-gray-400 overflow-y-auto">{partner.bio}</p>

                                            <div className="inline-block mt-2 w-52 text-1xl tracking-tight text-gray-300 lg:pb-0 sm:pb-3">
                                                <h3 className="inline">{partner.integrations} Integrations</h3>
                                                <span className="inline"> • </span>
                                                <h3 className="inline">{partner.industries} Industries</h3>
                                            </div>
                                            <a href="#" class="inline-block bg-orange-600 text-white hover:bg-orange-700 rounded-md shadow-sm text-center text-sm font-medium lg:w-28 lg:float-right p-2 sm:w-full">Read More</a>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default connect(
)(Partner)